import { fetchUserAttributes, updateUserAttributes, deleteUserAttributes } from "aws-amplify/auth";

const STORAGE_PREFIX = "accountSettings";

function getStorageKey(user) {
  const userId =
    user?.userId || user?.username || user?.attributes?.sub || "anonymous";

  return `${STORAGE_PREFIX}:${userId}`;
}

export function getDefaultAccountSettings(user) {
  return {
    profile: {
      email: user?.attributes?.email || "",
      company: user?.attributes?.["custom:company"] || "",
      location: user?.attributes?.address || "",
      disposalCompany: "Thommen",
      language: "de",
      timezone: "Europe/Zurich"
    },
    preferences: {
      emailNotifications: true,
      weeklySummary: false,
      productUpdates: true
    },
    workspace: {
      defaultEmissionsTab: "all",
      refreshIntervalSeconds: 30,
      includeTimestampInExport: true,
      highlightIndustryBenchmark: true
    }
  };
}

export async function loadAccountSettings(user) {
  const attributes = await fetchUserAttributes();
  const defaults = getDefaultAccountSettings({ ...user, attributes });
  const raw = localStorage.getItem(getStorageKey(user));

  if (!raw) {
    return defaults;
  }

  try {
    const parsed = JSON.parse(raw);
    const parsedProfile = parsed?.profile || {};
    return {
      ...defaults,
      ...parsed,
      profile: {
        ...defaults.profile,
        disposalCompany:
          parsedProfile.disposalCompany || defaults.profile.disposalCompany,
        language: parsedProfile.language || defaults.profile.language,
        timezone: parsedProfile.timezone || defaults.profile.timezone
      },
      preferences: {
        ...defaults.preferences,
        ...parsed.preferences
      },
      workspace: {
        ...defaults.workspace,
        ...parsed.workspace
      }
    };
  } catch {
    return defaults;
  }
}

export async function saveAccountSettings(user, settings) {
  const location = (settings.profile.location || "").trim();
  const attributes = await fetchUserAttributes();
  if (location !== (attributes.address || "")) {
    if (location) {
      await updateUserAttributes({ userAttributes: { address: location } });
    } else {
      await deleteUserAttributes({ userAttributeKeys: ["address"] });
    }
  }
  const payload = buildAccountSettingsPayload(user, {
    ...settings,
    profile: { ...settings.profile, location }
  });
  localStorage.setItem(getStorageKey(user), JSON.stringify(payload));
  return payload;
}

export function buildAccountSettingsPayload(user, settings) {
  return {
    profile: settings.profile,
    preferences: settings.preferences,
    workspace: settings.workspace,
    meta: {
      savedAt: new Date().toISOString(),
      source: "frontend-prototype"
    }
  };
}
